// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__2L2G2"};